export default __webpack_public_path__ + "static/media/investment-earn.a192893b.png";